/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { ColDef, PaginationStd, TableSetting, TableStd, ToolbarSetting } from 'app/components'
import React from 'react'
import { SystemDateDisplayFormat, UserProfileDto, UserProfileFilterDto, UserProfileService } from 'app/modules/core'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import { ImageAvatar } from 'app/components/images/ImageAvatar'
import { useGlobalModalContext } from 'setup/context/GlobalModal'
import { toast } from 'react-toastify'
import { catchErrorMsg } from 'app/modules/core/helpers/Helper'

const UserManagementPage: FC = () => {
    const msgBox = useGlobalModalContext()
    const navigate = useNavigate()
    const [reload, setReload] = React.useState<{}>()
    const [data, setData] = useState<UserProfileDto[]>([])
    const [totalRow, setTotalRow] = useState(0)
    const [searchParam, setSearchParam] = useState<UserProfileFilterDto>({
        isActive:undefined,
        page: 0,
        length: 10
    })

    const columnDef: ColDef<UserProfileDto>[] = [
        {
            label: 'Id',
            renderItem: ({item, index}) => item.id,
            hidden: true
        },
        {
            label: 'Avatar',
            renderItem: ({item, index}) => <ImageAvatar fielName={item.avatar} />,
        },
        {
            label: 'ชื่อ',
            renderItem: ({item, index}) => <>
            <div><a href={`/setting/users/`+item.id}>{item.firstName + ' ' + item.lastName}</a></div>
            <div>{item.email}</div>
            
            </>,
        },
        {
            label: 'รหัสพนักงาน',
            renderItem: ({item, index}) => item.employeeId
        },
        {
            label: 'ประเภท',
            renderItem: ({item, index}) => item.workingTypeCode,
            filterOption: [
                { value: 'FullTime', label: 'FullTime' },
                { value: 'PartTime', label: 'PartTime' },
            ],
        },
        {
            label: 'สังกัด',
            renderItem: ({item, index}) => item.affiliateCode,
            filterOption: [
                { value: 'SNH', label: 'SNH' },
                { value: 'SVH', label: 'SVH' },
                { value: 'Other', label: 'Other' },
            ],
        },
        {
            label: 'role',
            renderItem: ({item, index}) => item.roleCode,
            filterOption: [
                { value: 'Employee', label: 'Employee' },
                { value: 'Admin', label: 'Admin' },
            ],
        },
        {
            label: 'วันเริ่มงาน',
            renderItem: ({item, index}) => moment(item.startWorkingDate).format(SystemDateDisplayFormat)
        },
        {
            label: 'active',
            renderItem: ({item, index}) => item.isActive ? "Active" : "InActive",
            filterOption: [
                { value: true, label: 'Active' },
                { value: false, label: 'InActive' },
            ],
        }
    ]

    const tableSetting: TableSetting<UserProfileDto> = {
        showColAction: true,
        onBtnEditClick(e, id) {
            navigate('/setting/users/' + id)
        },
        onBtnDeleteClick(e, id) {
            msgBox.showModal({ title: 'Warning', message: 'Are you sure you want to delete.' }, (type) => {
                if (type === 'ok') {
                    UserProfileService.Delete(id).then((res) => {
                        toast.success('Delete Success.')
                        setReload({})
                    })
                        .catch((res) => {
                            toast.error(catchErrorMsg(res))
                        })
                }
            })
        },
        primaryKey: (item: UserProfileDto) => item.id,
    }
    const toolbarSetting: ToolbarSetting = {
        showBtnAdd: true,
        showFilter: true,
        showSearch: true,
        btnAddText: 'เพิ่ม user ใหม่',
        searchTextValue: '',
        onBtnAddClick: () => navigate('/setting/users/new'),
        onFilterApply: (val: { label: string; value: any }[]) => {
            const workingTypeCode = val.find((x) => x.label === 'ประเภท')?.value
            const affiliateCode = val.find(x => x.label === 'สังกัด')?.value
            const active = val.find(x => x.label === 'active')?.value
            const role = val.find(x => x.label === 'role')?.value
            setSearchParam((s) => ({
                ...s,
                workingTypeCode: workingTypeCode ? workingTypeCode : undefined,
                affiliateCode: affiliateCode,
                isActive: active ? Boolean(active) : undefined,
                roleCode: role,
                page: 0
            }))
        },
        onSearchTextChange: (e: any) => {
            setSearchParam((s) => ({
                ...s,
                searchText: e.target.value,
                page: 0
            }))
        }
    }

    useEffect(() => {
        const load = () => {
            UserProfileService.Search(searchParam).then((result) => {
                const row = result.data.result
                setTotalRow(result.data.totalRows)
                setData(row)
            })
        }
        load()
    }, [searchParam, reload])

    return (
        <>
            <PageTitle breadcrumbs={[]}></PageTitle>
            <div className={`card mb-5 mb-xl-8`}>

                {/* begin::Body */}
                <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div >
                        {/* begin::Table */}
                        <TableStd
                            tableSetting={tableSetting}
                            toolbarSetting={toolbarSetting}
                            columns={columnDef}
                            data={data}
                        />
                        {/* end::Table */}
                    </div>
                    <div>
                        <PaginationStd
                            pageSetting={{
                                currentPage: searchParam.page,
                                totalRow: totalRow,
                                pageSize: 10,
                            }}
                            onPageChange={(e: any, page: number) => setSearchParam({
                                ...searchParam,
                                page
                            })}
                            isLoading={false}
                        />
                    </div>
                    {/* end::Table container */}
                </div>
                {/* begin::Body */}
            </div>
        </>
    )
}
export { UserManagementPage }
